// @ts-nocheck
import { Trans } from '@lingui/react'

import { TENANT_AT, TENANT_IT } from 'shared/consts'
import {
  EXPERIMENT_VARIATION,
  TOTAAL_KORTING_AB_TEST,
} from 'shared/experiments/consts'
import Badge from 'views/components/atoms/Badge'
import Experiment from 'views/components/utils/optimizely/Experiment'
import Variant from 'views/components/utils/optimizely/Variant'
import { useLinePercentPromotions } from 'views/enhancers/useLinePercentPromotions'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { isDiscountValid } from 'views/utils/productUtils'
import './BadgeContainer.scss'

const BadgeContainer = ({
  product,
  discountBoundaries,
  promotions,
  publicRuntimeConfig: {
    publicConfig: { tenant, superScripts },
  },
  prescriptionType,
}) => {
  const supNoteDiscount = superScripts?.supNoteNumber?.toString() || '2' // Fallback for hydration
  const showSupNoteDiscount =
    tenant !== TENANT_IT && supNoteDiscount && tenant !== TENANT_AT

  const { linePercentPromotions } = useLinePercentPromotions()

  const productHasLinePercentPromotion =
    Array.isArray(promotions?.linePercent) &&
    promotions.linePercent.includes(product.offerId)

  const discount = productHasLinePercentPromotion
    ? product.lineDiscountedPriceDifferenceInPercent
    : product.discount

  const getDiscount = () =>
    Boolean(product.discount) && (
      <Badge
        color="red"
        discount
        value={product.discount}
        badgeType="discount"
        showSupNotes={Boolean(showSupNoteDiscount)}
        supNoteNumber={supNoteDiscount}
        ellipse
        dataQa="cart-entry-badgeType-discount"
      />
    )

  const getLinePercentDiscount = () => (
    <Badge
      color="red"
      discount
      value={product.lineDiscountedPriceDifferenceInPercent}
      badgeType="discount"
      showSupNotes={Boolean(showSupNoteDiscount)}
      supNoteNumber={supNoteDiscount}
      ellipse
      dataQa="cart-entry-badgeType-discount"
    />
  )

  const getLinePromotionDiscount = () =>
    linePercentPromotions.length > 0 ? (
      <Experiment name={TOTAAL_KORTING_AB_TEST} preventActivation>
        <Variant name={EXPERIMENT_VARIATION.DEFAULT}>
          {() => <>{getLinePercentDiscount()}</>}
        </Variant>

        <Variant name={EXPERIMENT_VARIATION.V1}>
          {() => <>{getLinePercentDiscount()}</>}
        </Variant>

        <Variant name={EXPERIMENT_VARIATION.V2}>
          {() => <>{getDiscount()}</>}
        </Variant>

        <Variant name={EXPERIMENT_VARIATION.V3}>
          {() => <>{getDiscount()}</>}
        </Variant>
      </Experiment>
    ) : (
      getLinePercentDiscount()
    )

  return (
    <div className={'a-BadgeContainer u-margin-large--right'}>
      {Boolean(product.rxBonus) && (
        <Badge
          className={'a-Badge--rxBonus a-Badge--size-x-large u-no-wrap'}
          pricing
          value={product.rxBonus}
          badgeType="rx"
          showSupNotes
          supNoteNumber="7" // Fallback for hydration
          ellipse
          dataQa={`cart-entry-badgeType-${prescriptionType}`}
          textcolor={'dark'}
        >
          {' '}
          <Trans id={'cart.prescriptionBonus.more.information.eRx'} />
        </Badge>
      )}
      {productHasLinePercentPromotion
        ? getLinePromotionDiscount()
        : getDiscount()}
      {Boolean(!product.rxBonus) &&
        !isDiscountValid(discount, discountBoundaries) && (
          <div
            style={{ width: '75px' }}
            className="o-ProductListing__badgeContainer-empty"
          />
        )}
    </div>
  )
}

export default withShopAndRuntimeConfig(BadgeContainer)
